import isEqual from 'lodash-es/isEqual'

import type { useTiers } from '../../../../../Perks/hooks/useTiers'
import type { useWelcomePostsQuery } from '../../hooks/useWelcomePostsQuery'
import type { FormValues } from '../../types'

export const getWelcomePostsFormData = (
  welcomePostsQuery: ReturnType<typeof useWelcomePostsQuery>['welcomePostsQuery'],
  tiers: NonNullable<ReturnType<typeof useTiers>['tiers']>,
): FormValues['welcomePosts'] => {
  if (welcomePostsQuery.data?.type === 'Different') {
    const posts = welcomePostsQuery.data.posts

    return tiers.reduce(
      (welcomePosts, tier) => {
        const welcomePost = posts.find((post) => isEqual(post.access.tiers?.[0], { id: tier.id }))

        if (welcomePost) {
          welcomePosts[tier.id] = {
            postType: welcomePost.type,
            title: welcomePost.title,
            description: welcomePost.description,
            image:
              'image' in welcomePost && welcomePost.image && 'url' in welcomePost.image
                ? welcomePost.image.url
                : undefined,
            imageResourceId:
              'imageResources' in welcomePost &&
              welcomePost.imageResources &&
              welcomePost.imageResources[0]
                ? welcomePost.imageResources[0].resourceId
                : undefined,
            video: 'mediaUrl' in welcomePost ? welcomePost.mediaUrl : undefined,
            videoThumbnail:
              welcomePost.type == 'Video' &&
              'image' in welcomePost &&
              welcomePost.image &&
              'url' in welcomePost.image
                ? welcomePost.image.url
                : undefined,
            videoType: 'upload',
            imageType:
              'image' in welcomePost && welcomePost.image ? welcomePost.image.type : undefined,
            status: welcomePost.statuses.resources,
          }
        } else {
          welcomePosts[tier.id] = {
            postType: 'Text',
            title: '',
            videoType: 'upload',
          }
        }

        return welcomePosts
      },
      {} as FormValues['welcomePosts'],
    )
  }

  return tiers.reduce(
    (tiers, tier) => {
      tiers[tier.id] = {
        postType: 'Text',
        title: '',
        videoType: 'upload',
      }

      return tiers
    },
    {} as FormValues['welcomePosts'],
  )
}
